<template>
  <div class="customer-list-container">
    <div class="page-header">
      <div class="page-title-block">
        <h2>客户列表</h2>
        <p class="page-subtitle">一线种植户与农资门店全景视图，助力精准回访</p>
      </div>
      <div class="header-actions">
        <el-button type="primary" @click="handleAddCustomer">
          <i class="el-icon-plus"></i> 添加客户
        </el-button>
        <el-button @click="handleExportAll">
          <i class="el-icon-download"></i> 导出全部
        </el-button>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <el-card class="search-card">
      <div class="search-form">
        <el-form :inline="true" :model="searchForm" class="search-inline-form">
          <el-form-item label="客户名称">
            <el-input v-model="searchForm.name" placeholder="请输入客户名称" clearable @input="handleSearch"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable @input="handleSearch"></el-input>
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="searchForm.address" placeholder="请输入地址" clearable @input="handleSearch"></el-input>
          </el-form-item>
          <el-form-item label="管理者">
            <el-select v-model="searchForm.managerId" placeholder="请选择管理者" clearable @change="handleSearch">
              <el-option v-for="manager in managers" :key="manager.id" :label="manager.name" :value="manager.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">
              <i class="el-icon-search"></i> 搜索
            </el-button>
            <el-button @click="handleReset">
              <i class="el-icon-refresh"></i> 重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    
    <!-- 移动端卡片视图 -->
    <div v-if="isMobile" class="customer-list-mobile">
      <div 
        v-for="(customer, idx) in pagedCustomers" 
        :key="customer.id" 
        class="customer-card"
      >
        <div class="customer-info">
          <p class="customer-serial">序号 {{ (currentPage - 1) * pageSize + idx + 1 }}</p>
          <h3>{{ customer.name }}</h3>
          <p><i class="el-icon-phone"></i> {{ customer.phone }}</p>
          <p><i class="el-icon-location-outline"></i> {{ customer.address }}</p>
          <p><i class="el-icon-user"></i> 管理者：{{ customer.manager && customer.manager.name ? customer.manager.name : '无' }}</p>
        </div>
        <div class="customer-actions">
          <el-button type="primary" size="mini" @click="handleViewCustomer(customer)">
            查看
          </el-button>
          <el-button type="success" size="mini" @click="handleEditCustomer(customer)">
            编辑
          </el-button>
          <el-button type="danger" size="mini" @click="handleDeleteCustomer(customer)">
            删除
          </el-button>
          <el-button size="mini" @click="handleExportCustomer(customer)">
            导出
          </el-button>
        </div>
      </div>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :hide-on-single-page="false"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
    
    <!-- 桌面端表格视图 -->
    <el-card v-else>
      <el-table :data="pagedCustomers" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" width="72" align="center">
          <template slot-scope="scope">
            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="客户名称" min-width="150"></el-table-column>
        <el-table-column prop="phone" label="联系电话" min-width="150"></el-table-column>
        <el-table-column prop="address" label="地址" min-width="200"></el-table-column>
        <el-table-column prop="manager.name" label="管理者" min-width="120"></el-table-column>
        <el-table-column label="操作" min-width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="handleViewCustomer(scope.row)">
              查看
            </el-button>
            <el-button type="success" size="small" @click="handleEditCustomer(scope.row)">
              编辑
            </el-button>
            <el-button type="danger" size="small" @click="handleDeleteCustomer(scope.row)">
              删除
            </el-button>
            <el-button size="small" @click="handleExportCustomer(scope.row)">
              导出
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :hide-on-single-page="false"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog
      title="已保存到下载目录"
      :visible.sync="exportPathDialogVisible"
      width="92%"
      :modal-append-to-body="true"
    >
      <div style="font-size: 13px; color: #606266; line-height: 1.6;">
        <div style="margin-bottom: 6px;">文件路径（可长按复制/截图）：</div>
        <div
          style="padding: 10px; background: #f5f7fa; border-radius: 8px; word-break: break-all; color: #303133;"
        >
          {{ exportSavedPath || '-' }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="copyExportPath" :disabled="!exportSavedPath">复制路径</el-button>
        <el-button type="primary" size="mini" @click="exportPathDialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'CustomerList',
  data() {
    return {
      customers: [],
      filteredCustomers: [],
      selectedCustomers: [],
      managers: [],
      currentPage: 1,
      pageSize: 10,
      isMobile: false,
      exportSaving: false,
      exportPathDialogVisible: false,
      exportSavedPath: '',
      searchForm: {
        name: '',
        phone: '',
        address: '',
        managerId: ''
      }
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.loadCustomers()
    this.loadManagers()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  computed: {
    /** 与表格行数一致，避免 total 与列表不同步 */
    totalCount() {
      return (this.filteredCustomers && this.filteredCustomers.length) || 0
    },
    /** 当前页数据（前端分页，与 el-pagination 一致） */
    pagedCustomers() {
      const list = this.filteredCustomers || []
      const start = (this.currentPage - 1) * this.pageSize
      return list.slice(start, start + this.pageSize)
    }
  },
  watch: {
    filteredCustomers() {
      const len = (this.filteredCustomers && this.filteredCustomers.length) || 0
      const maxPage = Math.max(1, Math.ceil(len / this.pageSize) || 1)
      if (this.currentPage > maxPage) {
        this.currentPage = maxPage
      }
    }
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768
    },
    
    // 加载客户列表
    normalizeCustomerList(payload) {
      if (Array.isArray(payload)) return payload
      if (payload && Array.isArray(payload.data)) return payload.data
      if (payload && Array.isArray(payload.content)) return payload.content
      return []
    },
    /** 仅做搜索条件过滤；数据权限以接口 /customers 返回为准，避免前后端重复过滤导致条数变少、分页失效 */
    applySearchFilters() {
      const { name, phone, address, managerId } = this.searchForm
      let list = Array.isArray(this.customers) ? [...this.customers] : []
      if (name) list = list.filter(c => c.name && String(c.name).includes(name))
      if (phone) list = list.filter(c => c.phone && String(c.phone).includes(phone))
      if (address) list = list.filter(c => c.address && String(c.address).includes(address))
      if (managerId != null && managerId !== '') {
        list = list.filter(c => c.manager && c.manager.id === managerId)
      }
      this.filteredCustomers = list
    },
    loadCustomers() {
      request.get('/customers')
        .then(response => {
          this.customers = this.normalizeCustomerList(response)
          this.applySearchFilters()
        })
        .catch(error => {
          console.error('加载客户列表失败:', error)
          this.$message.error('加载客户列表失败')
        })
    },
    
    // 加载管理者列表
    loadManagers() {
      request.get('/users')
        .then(response => {
          this.managers = response.data || response
        })
        .catch(error => {
          console.error('加载管理者列表失败:', error)
          this.$message.error('加载管理者列表失败')
        })
    },
    
    // 搜索客户（条件全空时与重置效果一致，显示全部）
    handleSearch() {
      this.currentPage = 1
      this.applySearchFilters()
    },
    
    // 重置搜索条件
    handleReset() {
      this.searchForm = {
        name: '',
        phone: '',
        address: '',
        managerId: ''
      }
      this.applySearchFilters()
      this.currentPage = 1
    },
    
    // 选择客户
    handleSelectionChange(selection) {
      this.selectedCustomers = selection
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
    },
    
    // 当前页码变化
    handleCurrentChange(current) {
      this.currentPage = current
    },
    
    // 查看客户详情
    handleViewCustomer(customer) {
      this.$router.push(`/customers/${customer.id}`)
    },
    
    // 编辑客户
    handleEditCustomer(customer) {
      this.$router.push(`/customers/edit/${customer.id}`)
    },
    
    // 添加客户
    handleAddCustomer() {
      this.$router.push('/customers/new')
    },
    
    // 删除客户
    handleDeleteCustomer(customer) {
      this.$confirm(`确定要删除客户 "${customer.name}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.delete(`/customers/${customer.id}`)
          .then(() => {
            this.$message.success('删除客户成功')
            this.loadCustomers() // 重新加载客户列表
          })
          .catch(error => {
            console.error('删除客户失败:', error)
            this.$message.error('删除客户失败')
          })
      }).catch(() => {
        // 取消删除
      })
    },
    
    // 导出单个客户
    handleExportCustomer(customer) {
      // 使用axios下载二进制文件
      this.downloadFile(`/api/excel/customer/${customer.id}`, `客户回访记录_${customer.name}.xlsx`)
    },
    
    // 导出全部客户
    handleExportAll() {
      this.downloadFile('/api/excel/customers/all', '客户信息列表.xlsx')
    },
    
    // 通用文件下载方法
    downloadFile(url, filename) {
      // HBuilder(5+) App：优先使用原生 downloader（更稳定，且支持 header）
      if (window.plus && window.plus.downloader) {
        this.downloadFileByPlus(url, filename)
        return
      }

      // 创建新的axios实例，绕过全局响应拦截器
      const downloadAxios = this.$axios.create({
        baseURL: '',
        responseType: 'blob', // 重要：指定响应类型为二进制数据
        timeout: 30000
      })
      
      // 添加认证token
      const token = localStorage.getItem('token')
      
      downloadAxios.get(url, {
        headers: {
          'Authorization': token ? `Bearer ${token}` : ''
        }
      })
      .then(response => {
        this.handleFileDownload(response.data, filename)
      })
      .catch(error => {
        console.error('文件下载失败:', error)
        this.$message.error('文件下载失败')
      })
    },
    
    // 处理文件下载
    handleFileDownload(blob, filename) {
      // 创建下载链接
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      
      // 触发下载
      document.body.appendChild(link)
      link.click()
      
      // 清理
      setTimeout(() => {
        URL.revokeObjectURL(url)
        document.body.removeChild(link)
      }, 100)
    },

    _toast(msg) {
      try {
        if (window.plus && window.plus.nativeUI && window.plus.nativeUI.toast) {
          window.plus.nativeUI.toast(String(msg || ''))
        } else if (this.$message) {
          this.$message(msg)
        }
      } catch (e) {
        // ignore
      }
    },

    // HBuilder App：用 plus.downloader 下载到 _downloads（支持 header，最稳）
    downloadFileByPlus(url, filename) {
      if (this.exportSaving) return
      this.exportSaving = true
      try {
        const token = localStorage.getItem('token')
        const safeName = String(filename || 'export.xlsx').replace(/[\\/:*?"<>|]/g, '_')
        const fullUrl = /^https?:\/\//i.test(url)
          ? url
          : `${window.location.origin}${url.startsWith('/') ? '' : '/'}${url}`

        const waiting = window.plus && window.plus.nativeUI && window.plus.nativeUI.showWaiting
          ? window.plus.nativeUI.showWaiting('正在导出...')
          : null

        // 先下载到临时目录，导出完成后再让用户选择“打开/保存”
        const tempTarget = `_doc/exports/${Date.now()}_${safeName}`
        const task = window.plus.downloader.createDownload(
          fullUrl,
          { filename: tempTarget },
          (download, status) => {
            if (waiting && waiting.close) waiting.close()
            this.exportSaving = false
            if (status === 200) {
              this.showExportActionSheet(download.filename, safeName)
            } else {
              console.error('导出失败 status=', status, download)
              this._toast(`导出失败（${status}）`)
            }
          }
        )
        if (token && task && task.setRequestHeader) {
          task.setRequestHeader('Authorization', `Bearer ${token}`)
        }
        task.start()
      } catch (e) {
        console.error('App 导出失败:', e)
        this._toast('导出失败')
        this.exportSaving = false
      }
    },

    showExportActionSheet(tempFilePath, displayName) {
      if (!(window.plus && window.plus.nativeUI)) {
        if (window.plus && window.plus.runtime && window.plus.runtime.openFile) {
          window.plus.runtime.openFile(tempFilePath)
        }
        return
      }

      window.plus.nativeUI.actionSheet(
        {
          title: '导出完成',
          cancel: '取消',
          buttons: [
            { title: '直接打开' },
            { title: '保存到下载目录' }
          ]
        },
        (e) => {
          if (e.index === 1) {
            if (window.plus && window.plus.runtime && window.plus.runtime.openFile) {
              window.plus.runtime.openFile(tempFilePath)
            }
            return
          }
          if (e.index === 2) this.copyPlusFileToPublicDownloads(tempFilePath, displayName)
        }
      )
    },

    copyPlusFileToPublicDownloads(srcPath, destName) {
      if (this.exportSaving) return
      this.exportSaving = true
      this.copyPlusFile(
        srcPath,
        '_downloads/',
        destName,
        '已保存到下载目录',
        (savedPath) => {
          this.exportSavedPath = savedPath || ''
          this.exportPathDialogVisible = true
        }
      )
    },

    copyPlusFile(srcPath, destDirUrl, destName, successToast, onSaved) {
      try {
        if (!(window.plus && window.plus.io)) return

        window.plus.io.resolveLocalFileSystemURL(
          srcPath,
          (srcEntry) => {
            const finish = () => { this.exportSaving = false }

            const doCopyToDir = (dirEntry) => {
              // 目标已存在时 copyTo 会失败，这里改为“先删后拷贝”实现覆盖保存
              const doCopy = () => {
                srcEntry.copyTo(
                  dirEntry,
                  destName,
                  (newEntry) => {
                    this._toast(successToast || '保存成功')
                    if (newEntry && newEntry.toLocalURL) {
                      console.log('导出文件路径:', newEntry.toLocalURL())
                      onSaved && onSaved(newEntry.toLocalURL())
                    } else {
                      onSaved && onSaved('')
                    }
                    finish()
                  },
                  (err) => {
                    console.error('保存失败(copyTo):', err)
                    this._toast('保存失败')
                    finish()
                  }
                )
              }

              if (!dirEntry || !dirEntry.getFile) {
                doCopy()
                return
              }

              dirEntry.getFile(
                destName,
                { create: false },
                (existEntry) => {
                  existEntry.remove(
                    () => doCopy(),
                    () => doCopy()
                  )
                },
                () => doCopy()
              )
            }

            // _downloads：使用 requestFileSystem 获取目录对象（更兼容 Android 10+）
            if (destDirUrl === '_downloads/') {
              window.plus.io.requestFileSystem(
                window.plus.io.PUBLIC_DOWNLOADS,
                (fs) => {
                  fs.root.getDirectory(
                    'khgl',
                    { create: true, exclusive: false },
                    (khglDir) => doCopyToDir(khglDir),
                    () => doCopyToDir(fs.root)
                  )
                },
                (err) => {
                  console.error('无法访问 _downloads:', err)
                  this._toast('无法访问下载目录')
                  finish()
                }
              )
              return
            }

            window.plus.io.resolveLocalFileSystemURL(
              destDirUrl,
              (dirEntry) => doCopyToDir(dirEntry),
              (err) => {
                console.error('无法访问目标目录:', err, destDirUrl)
                this._toast('无法访问保存目录')
                finish()
              }
            )
          },
          (err) => {
            console.error('无法访问临时文件:', err, srcPath)
            this._toast('导出文件不存在')
            this.exportSaving = false
          }
        )
      } catch (e) {
        console.error('保存失败:', e)
        this._toast('保存失败')
        this.exportSaving = false
      }
    },

    copyExportPath() {
      const text = this.exportSavedPath || ''
      if (!text) return

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this._toast('已复制路径')
        }).catch(() => {
          this._fallbackCopyText(text)
        })
        return
      }
      this._fallbackCopyText(text)
    },

    _fallbackCopyText(text) {
      try {
        const el = document.createElement('textarea')
        el.value = text
        el.setAttribute('readonly', '')
        el.style.position = 'fixed'
        el.style.left = '-9999px'
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        this._toast('已复制路径')
      } catch (e) {
        this._toast('复制失败，请长按路径手动复制')
      }
    }
  }
}
</script>

<style scoped>
.customer-list-container {
  width: 100%;
  padding: 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  padding: 14px 4px 6px;
}

.page-title-block h2 {
  margin: 0;
  font-size: 22px;
  color: #0f8f59;
}

.page-subtitle {
  margin-top: 4px;
  font-size: 12px;
  color: #80848f;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.search-card {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(23, 182, 118, 0.08);
  border: none;
}

/* 移动端客户卡片样式 */
.customer-list-mobile {
  display: grid;
  gap: 15px;
}

.customer-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
}

.customer-serial {
  margin: 0 0 6px 0;
  font-size: 12px;
  color: #909399;
}

.customer-info h3 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
  font-weight: bold;
}

.customer-info p {
  margin: 5px 0;
  color: #606266;
  font-size: 14px;
}

.customer-info i {
  margin-right: 5px;
  color: #409eff;
}

.customer-actions {
  margin-top: 15px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.customer-actions .el-button {
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
  
  .header-actions {
    justify-content: center;
  }
  
  .customer-card {
    padding: 12px;
  }

  .customer-list-container {
    padding: 0 4px;
  }
  
  .customer-info h3 {
    font-size: 15px;
  }
  
  .customer-info p {
    font-size: 13px;
  }
  
  .customer-actions {
    justify-content: center;
  }
}
</style>